export type PaidCourseCtaAction = "start" | "unlock" | "buy_credits" | "login" | "unavailable";

export type PaidCourseCtaState = {
  action: PaidCourseCtaAction;
  label: string;
  disabledReason: string | null;
};

export function requiresCreditsUnlock(args: {
  access: "free" | "paid" | null | undefined;
  courseCostCredits: number | null | undefined;
}): boolean {
  if (args.access !== "paid") return false;
  const cost = typeof args.courseCostCredits === "number" ? args.courseCostCredits : Number(args.courseCostCredits);
  if (!Number.isFinite(cost)) return false;
  return Math.floor(cost) > 0;
}

export function formatCreditsLabel(balanceCredits: number): string {
  const safe = Number.isFinite(balanceCredits) ? Math.max(0, Math.floor(balanceCredits)) : 0;
  return `Credits: ${safe}`;
}

export function buildCheckoutRedirectPath(args: { lang: string; courseSlug: string; requiredCredits: number }): string {
  const returnTo = `/${args.lang}/courses/${args.courseSlug}`;
  const url = new URL(`/${args.lang}/checkout`, "https://zipvibe.local");
  url.searchParams.set("returnTo", returnTo);
  url.searchParams.set("desiredCourseSlug", args.courseSlug);
  url.searchParams.set("requiredCredits", String(Math.max(1, Math.floor(args.requiredCredits))));
  return `${url.pathname}${url.search}`;
}

export function resolvePaidCourseCtaState(args: {
  isAuthenticated: boolean;
  isUnlocked: boolean;
  hasLessons: boolean;
  balanceCredits: number;
  courseCostCredits: number;
}): PaidCourseCtaState {
  if (!args.hasLessons) {
    return {
      action: "unavailable",
      label: "Unlock course",
      disabledReason: "This course structure is being prepared.",
    };
  }

  if (!args.isAuthenticated) {
    return {
      action: "login",
      label: "Unlock course",
      disabledReason: "Sign in to continue.",
    };
  }

  if (args.isUnlocked) {
    return {
      action: "start",
      label: "Start course",
      disabledReason: null,
    };
  }

  if (args.balanceCredits >= args.courseCostCredits) {
    return {
      action: "unlock",
      label: "Unlock course",
      disabledReason: null,
    };
  }

  return {
    action: "buy_credits",
    label: "Buy credits",
    disabledReason: null,
  };
}
